import { makeStyles } from "@mui/styles";
const useMobilePasswordStyles = makeStyles(() => {
  return {
    default: {
      background: "#fff",
      borderRadius: "8px",
      fontFamily: "Lato",
      fontSize: "16px",
      fontWeight: 400,
    },
  };
});

export default useMobilePasswordStyles;
